import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
import { Button } from '../ui/Button';
import { featuredStory, latestNews } from '../../data/news';
export function LatestUpdates() {
  return <section aria-labelledby="news-heading" className="bg-white py-16 sm:py-20 lg:py-28" data-id="element-215" data-mp="2t4qpjps5x66k">
      <div className="mx-auto max-w-content px-4 sm:px-6 lg:px-10" data-id="element-216" data-mp="3gul0g1sx8ko6">
        <SectionHeading eyebrow="Newsroom" title="Latest from the campaign" action={<Button variant="secondary" data-id="element-218" data-mp="3ky0xv0ctep1x">
              View all updates
              <ArrowRightIcon aria-hidden className="h-[18px] w-[18px]" data-id="element-219" data-mp="3749w4e5bs9gr" />
            </Button>} data-id="element-217" data-mp="3gveb3dv03ubl" />

        <div className="mt-12 grid gap-8 lg:grid-cols-12 lg:gap-10" data-id="element-220" data-mp="3c1ry1kkxdof9">
          <Reveal className="lg:col-span-7" data-id="element-221" data-mp="3nay1051ukja">
            <a href="/news" className="group block" data-id="element-222" data-mp="8esyzo72ol49">
              <div className="overflow-hidden rounded-media" data-id="element-223" data-mp="8fkukz0o6iuj">
                <img src={featuredStory.image} alt="" loading="lazy" className="aspect-[16/9] w-full object-cover transition-transform duration-300 ease-emphasis group-hover:scale-[1.02]" data-id="element-224" data-mp="ourra7hk5yn9" />
              </div>
              <div className="mt-5 flex items-center gap-3 text-[12px] font-bold uppercase tracking-[0.12em]" data-id="element-225" data-mp="tue62ld1bmy6">
                <span className="rounded bg-green-50 px-2 py-1 text-green-700" data-id="element-226" data-mp="18i90q7als1dw">
                  {featuredStory.category}
                </span>
                <span className="text-slate-500" data-id="element-227" data-mp="13jo1aa36dlqi">{featuredStory.date}</span>
              </div>
              <h3 className="mt-3 max-w-[26ch] font-display text-[24px] leading-snug text-ink transition-colors duration-150 ease-emphasis group-hover:text-green-700 sm:text-[28px]" data-id="element-228" data-mp="1hixf533ws3rb">
                {featuredStory.title}
              </h3>
              <p className="mt-3 max-w-2xl text-[16px] leading-relaxed text-slate-600" data-id="element-229" data-mp="3ec8pob302pwl">
                {featuredStory.excerpt}
              </p>
              <span className="mt-4 inline-flex items-center gap-2 text-[15px] font-semibold text-green-700" data-id="element-230" data-mp="1iaf1mu5fbfd5">
                Read the full address
                <ArrowRightIcon aria-hidden className="h-4 w-4 transition-transform duration-200 ease-emphasis group-hover:translate-x-1" data-id="element-231" data-mp="1s79y77i4z5os" />
              </span>
            </a>
          </Reveal>

          <ul className="lg:col-span-5" data-id="element-232" data-mp="216wyfpz4q5g9">
            {latestNews.map((item, index) => <li key={item.title} data-id="element-233" data-mp="265i2y1lezbai" data-mpi={index}>
                <Reveal delay={index * 0.05} data-id="element-234" data-mp="264q9awbdnnmv">
                  <a href="/news" className="group flex gap-4 border-b border-sand-200 py-5 first:pt-0 last:border-b-0" data-id="element-235" data-mp="2ax9k5liok4nz">
                    <span className="h-[84px] w-[112px] shrink-0 overflow-hidden rounded-lg" data-id="element-236" data-mp="2jyhe5re5yjc9">
                      <img src={item.image} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-300 ease-emphasis group-hover:scale-[1.03]" data-id="element-237" data-mp="2ox1380o20b8u" />
                    </span>
                    <span className="flex-1" data-id="element-238" data-mp="48he2s7wdyi3">
                      <span className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.1em]" data-id="element-239" data-mp="4bdaud80eh4y">
                        <span className="text-green-700" data-id="element-240" data-mp="w0faymsybzz8">{item.category}</span>
                        <span className="text-slate-500" data-id="element-241" data-mp="w2jciy3domwc">{item.date}</span>
                      </span>
                      <span className="mt-1.5 block font-display text-[17px] leading-snug text-ink transition-colors duration-150 ease-emphasis group-hover:text-green-700" data-id="element-242" data-mp="s0y3jntyssrf">
                        {item.title}
                      </span>
                      <span className="mt-1.5 block text-[13px] leading-relaxed text-slate-600" data-id="element-243" data-mp="1foxwmuer0v96">
                        {item.excerpt}
                      </span>
                    </span>
                  </a>
                </Reveal>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}